import React, { Component } from 'react';
import ReactTextTransition from 'react-text-transition';

class TextAnimate extends Component {
    state = {
        paragraphIndex: 0,
    };

    componentDidMount() {
        setInterval(() => {
            this.setState({
                paragraphIndex:
                    this.state.paragraphIndex + 1 === this.props.paragraphs.length
                        ? 0
                        : this.state.paragraphIndex + 1,
            });
        }, 3000);
    }

    render() {
        return (
            <div
                onClick={() =>
                    this.props.onClick(this.props.paragraphs[this.state.paragraphIndex].id)
                }
            >
                <ReactTextTransition
                    text={this.props.paragraphs[this.state.paragraphIndex].title}
                    springConfig={{ stiffness: 50, damping: 20 }}
                />
            </div>
        );
    }
}

export default TextAnimate;
